import dep_api from "@/lib/dep-api";
import DepStore from "@/vuex/index";
import CxltToastr from "cxlt-vue2-toastr";
import "cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css";
import moment from "moment";
import store2 from "store2";
import VTooltip from "v-tooltip";
import Vue from "vue";
import VModal from "vue-js-modal";
import vMoment from "vue-moment";
import "../sass/dep-theme.scss";
import { SET_API, SET_STORAGE } from "../vuex/mutation-types";
import ConfirmModal from "@/components/global/modal/ModalConfirmation";
import { confirmModalStyle } from "@/components/global/modal/modal_styles";
import { menuCopyFilter } from "@/components/global/layout/menu/menu_names";
import {
  createSubTable,
  destroySubTable,
} from "../components/global/webon/webon-table/subtables/SubtableUtils";

const S3_PATH = window.AWS_URL || process.env.VUE_APP_S3_URL;
const IMPACT_S3_PATH =
  window.IMPACT_AWS_URL || process.env.VUE_APP_S3_IMPACT_URL;
const DOWNLOAD_URL = window.DOWNLOAD_URL || process.env.VUE_APP_DOWNLOAD_URL;

const appendS3URL = function (value) {
  return S3_PATH + value;
};

const appendImpactS3URL = function (value) {
  return IMPACT_S3_PATH + value;
};

const appendDOWNLOADURL = function (value) {
  return DOWNLOAD_URL + value;
};

const appendIMGURL = function (value) {
  return `/img/${value}`;
};

const formatBytes = function (bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

const roundDecimals = function (value, numberOfDecimals) {
  if (!numberOfDecimals) numberOfDecimals = 1;
  const multiplier = Math.pow(10, numberOfDecimals);
  var number = Math.floor(value * multiplier) / multiplier;

  var s = number.toString();
  if (s.indexOf(".") == -1) s += ".";
  while (s.length < s.indexOf(".") + (numberOfDecimals + 1)) s += "0";
  return s;
};

const currencyTruncate = function (value) {
  const amount = value || 0;
  const currencyFormat = amount
    .toString()
    .match(/^-?\d+(?:\.\d{0,2})?/)[0]
    .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  return `$ ${currencyFormat}`;
};

const currencyFormat = function (value) {
  const amount = value || 0;
  const currencyFormat = amount
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  return `$ ${currencyFormat}`;
};


const utcDate = function (date, format) {
  const formattedDate = moment.utc(date).toDate();
  return moment(formattedDate).format(format ? format : "DD-MM-YYYY");
};

const momento = window.moment;

export const EventBus = new Vue();

const MyPlugin = {
  install: function (Vue, options) {
    //dep filters
    Vue.filter("s3url", appendS3URL);
    Vue.filter("impacts3url", appendImpactS3URL);
    Vue.filter("downloadUrl", appendDOWNLOADURL);
    Vue.filter("baseImg", appendIMGURL);
    Vue.filter("formatBytes", formatBytes);
    Vue.filter("roundDecimals", roundDecimals);
    Vue.filter("currencyFormat", currencyFormat);
    Vue.filter("currencyTruncate", currencyTruncate);
    Vue.filter("lowercase", (val) => {
      return val.toLowerCase();
    });
    Vue.filter("utcDate", utcDate);
    Vue.filter("menuCopy", menuCopyFilter);
    Vue.directive("numberOnly", {
      bind: function () {
        this.handler = function () {
          this.el.value = this.el.value.replace(/\D+/, "");
        }.bind(this);
        this.el.addEventListener("input", this.handler);
      },
      unbind: function () {
        this.el.removeEventListener("input", this.handler);
      },
    });

    //Para los modales
    Vue.use(VModal, {
      dynamic: true,
      injectModalsContainer: true,
      dialog: true,
    });

    //Tooltips y popovers
    Vue.use(VTooltip);

    Vue.use(CxltToastr, {
      position: "top right",
      showDuration: 1000,
      hideDuration: 1000,
      timeOut: 5000,
      showMethod: "pulse",
      hideMethod: "pulse",
    });

    //Moment filter
    Vue.use(vMoment, {
      moment: momento,
    });
    Vue.prototype.$moment.locale("es");

    // set Store
    Vue.mixin({
      store: DepStore,
      computed: {
        //userType shortcut properties;
        $accessLevel() {
          return this.$store.getters["User/accessLevel"];
        },
        $isGuestUser() {
          return this.$store.getters["User/isGuest"];
        },
        $isStudentUser() {
          return this.$store.getters["User/isStudent"];
        },
        $isCoachUser() {
          return this.$store.getters["User/isCoach"];
        },
        $isCoordUser() {
          return this.$store.getters["User/isCoord"];
        },
        $isAdminUser() {
          return this.$store.getters["User/isAdmin"];
        },
        $isCallCenterUser() {
          return this.$store.getters["User/isCallCenter"];
        },
        $isKnComUser() {
          return this.$store.getters["User/isKnCom"];
        },
        $isKnComAdminUser() {
          return this.$store.getters["User/isKnComAdmin"];
        },
        $isRelative() {
          return this.$store.getters["User/isRelative"];
        },
      },
    });
    //set global api
    var api = (Vue.prototype.$depAPI = Vue.depAPI = dep_api(DepStore));

    DepStore.commit(SET_API, api);

    //global storage
    Vue.prototype.$storage = store2;

    DepStore.commit(SET_STORAGE, store2);

    //used to read dot object knotation from strings
    Vue.prototype.$propertyByString = function propertyByString(o, s) {
      s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
      s = s.replace(/^\./, ""); // strip a leading dot
      var a = s.split(".");
      for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
          o = o[k];
        } else {
          return;
        }
      }
      return o;
    };

    Vue.prototype.$singleToast = function (type, title) {
      switch (type) {
        case "success":
          this.$toast.success({ title });
          break;
        case "warn":
          this.$toast.warn({ title });
          break;
        case "error":
          this.$toast.error({ title });
          break;
        default:
          this.$toast.info({ title });
      }
    };

    Vue.prototype.$confirmModal = function ({ title, text, okHandler }) {
      this.$modal.show(
        ConfirmModal,
        { title, text, okHandler, name: "confirm-modal" },
        confirmModalStyle
      );
    };

    Vue.prototype.$showLoading = function () {
      $(".kno-loader-container").removeClass("kno-loader-hidden");
    };

    Vue.prototype.$hideLoading = function () {
      $(".kno-loader-container").addClass("kno-loader-hidden");
    };

    Vue.prototype.$onCloseModal = function () {
      $(".select2-in-modal").select2("close");
    };

    Vue.prototype.$createSubTable = createSubTable;
    Vue.prototype.$destroySubTable = destroySubTable;

    const unregisterStoreModule = function (moduleName) {
      try {
        DepStore.unregisterModule(moduleName);
      } catch (err) {
        Vue.$log.error(
          `There was an error unregistering module ${moduleName}. More details: ${err}`
        );
      }
    };

    Vue.prototype.$unregisterStoreModule = unregisterStoreModule;

    Vue.prototype.$registerStoreModule = function (moduleName, store) {
      unregisterStoreModule(moduleName);
      DepStore.registerModule(moduleName, store);
    };

    Vue.depStore = DepStore;
  },
};

export default MyPlugin;
